"use client"

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { Loader2 } from "lucide-react"
import { useState } from "react"

interface ReportIssueModalProps {
    isOpen: boolean
    onClose: () => void
}

export function ReportIssueModal({ isOpen, onClose }: ReportIssueModalProps) {
    const [loading, setLoading] = useState(true)

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="sm:max-w-[600px] h-[80vh] p-0 overflow-hidden flex flex-col">
                <DialogHeader className="p-6 pb-2">
                    <DialogTitle>Report an Issue</DialogTitle>
                    <DialogDescription>
                        Fill out the form below to let us know about any problems or suggestions.
                    </DialogDescription>
                </DialogHeader>
                <div className="flex-1 relative min-h-[400px]">
                    {loading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-background/50 backdrop-blur-sm z-10">
                            <Loader2 className="h-8 w-8 animate-spin text-primary" />
                        </div>
                    )}
                    <iframe
                        src="https://dsatschool.fillout.com/t/cUuZ7Q3Cj1us"
                        className="w-full h-full border-0"
                        onLoad={() => setLoading(false)}
                        title="Report Issue Form"
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}
